var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desk",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plano---upgrade-plano---erro-cartao",
    transform: "translate(-700.000000, -550.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(520.000000, 500.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-error",
    transform: "translate(181.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    stroke: "#FC2351",
    strokeWidth: 2,
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "!",
    transform: "translate(18.666667, 10.666667)",
    fill: "#FC2351"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.4666667,
    cy: 17.8962963,
    rx: 1.4666667,
    ry: 1.30370373
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 2.66666667,
    height: 14.2222222,
    rx: 1.33333333
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.1beb4b728f097b7d491557e87f76a88e.svg";
export { ForwardRef as ReactComponent };